"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = (0, tslib_1.__importStar)(require("react"));
const lib_1 = require("../../lib");
const NavItem_1 = require("./components/NavItem");
const NavLink_1 = require("./components/NavLink");
const NavHeader_1 = require("./components/NavHeader");
const NavFooter_1 = require("./components/NavFooter");
const NavMenu_1 = require("./components/NavMenu");
const NavTree_1 = require("./components/NavTree");
const components_1 = require("./components");
/**
 * Nav component
 *
 * @visibleName Nav
 */
class Nav extends React.Component {
    render() {
        const { children, className } = this.props;
        return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)(className, (0, lib_1.bem)('nav')) }, { children: children }), void 0);
    }
}
exports.Nav = Nav;
Nav.Item = NavItem_1.NavItem;
Nav.Link = NavLink_1.NavLink;
Nav.Header = NavHeader_1.NavHeader;
Nav.Menu = NavMenu_1.NavMenu;
Nav.Footer = NavFooter_1.NavFooter;
Nav.Tree = NavTree_1.NavTree;
Nav.Heading = components_1.NavHeading;
//# sourceMappingURL=Nav.js.map